import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import SmartFeedPagination from "~/dynamic-components/options/smart-feed-pagination";

export default class SmartFeedSeeMoreAlignment extends BaseOption {
  static label = "See More Alignment";
  static userInterfaceComponent = {
    component: inspectorTools.RADIO_BAR,
    iconSize: 24,
    props: {
      options: [
        {
          icon: "align-left",
          value: "left",
        },
        {
          icon: "align-center",
          value: "center",
        },
        {
          icon: "align-right",
          value: "right",
        },
      ],
    },
  };

  static defaultValue = "center";

  static canShow(paginationType) {
    let paginationTypeId = paginationType;
    if (typeof paginationTypeId === "object") {
      paginationTypeId = paginationTypeId.id;
    }
    return paginationTypeId === SmartFeedPagination.optionValues.clickToPaginate.id;
  }
}
